// @flow

import React from 'react'
import {connect} from 'react-redux'
import {portfoliosActions} from '@/store'
import GoSync from 'react-icons/lib/go/sync'

type Props = {
  refreshPortfoliosData: () => void,
}

const RawSyncButton = (props: Props) =>
  <button id='portfolios_refresh_button'
    className="btn btn-success btn-xs refresh-button"
    onClick={props.refreshPortfoliosData}
  >
    <GoSync/>
  </button>

export default connect(
  null,
  portfoliosActions,
)(RawSyncButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/refresh-button.js